var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 49,
    viewBox: "0 0 97 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.22327V38.9038V46.3706",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.22327V38.9038V46.3706",
    stroke: "#202020",
    strokeWidth: 5.17551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9289 39.6132H4.86981",
    stroke: "#202020",
    strokeWidth: 5.17551,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7955 15.5682V40.2436V46.264",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7955 15.5682V40.2436V46.264",
    stroke: "#202020",
    strokeWidth: 5.17551,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2626 34.543V19.7189L73.2134 22.1673L78.6247 34.5125L31.2626 34.543Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 3.45034,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1101 20.9979V33.0204H8.97162",
    stroke: "current",
    strokeWidth: 5.17551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 29.0372C18.9142 29.0372 21.6519 26.2995 21.6519 22.9224C21.6519 19.5453 18.9142 16.8076 15.5371 16.8076C12.16 16.8076 9.4223 19.5453 9.4223 22.9224C9.4223 26.2995 12.16 29.0372 15.5371 29.0372Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0643 8.22327H16.8952L13.0643 12.5871H16.8952",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0643 8.22327H16.8952L13.0643 12.5871H16.8952",
    stroke: "current",
    strokeWidth: 0.862585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5283 11.0005H24.3591L20.5283 15.3642H24.3591",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5283 11.0005H24.3591L20.5283 15.3642H24.3591",
    stroke: "current",
    strokeWidth: 0.862585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7364 1H23.5673L19.7364 5.36379H23.5673",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7364 1H23.5673L19.7364 5.36379H23.5673",
    stroke: "current",
    strokeWidth: 0.862585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRest);
export default __webpack_public_path__ + "static/media/rest.acd66588e1b59ff01b45aef18d1afe7a.svg";
export { ForwardRef as ReactComponent };